import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleButton"]

  async toggle() {
    const invoiceId = this.toggleButtonTarget.dataset.invoiceId
    const toggleButton = this.toggleButtonTarget

    // Disable button during request
    toggleButton.disabled = true

    try {
      // Include current URL params (company_id, etc.) for proper context
      const currentParams = new URLSearchParams(window.location.search)
      const url = `/invoices/${invoiceId}/toggle_exportable?${currentParams.toString()}`

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const contentType = response.headers.get('content-type') || ''
      if (!contentType.includes('text/vnd.turbo-stream.html')) throw new Error(`Unexpected response: ${response.status}`)

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      console.error('Error toggling exportable:', error)
      window.alert('Nepavyko pakeisti eksporto būsenos. Bandykite dar kartą.')
    } finally {
      // Re-enable button
      toggleButton.disabled = false
    }
  }
}
